import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { SiteConfigHelper } from "@app/shared/utils/site-config.helper";
import { SubRegion } from "@app/shared/classes/sub-region";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";

export enum OrgUnitFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  subRegion = "subRegion",
  country = "country",
  kpiName = "kpiName",
  kpiDate = "kpiDate",
  compliance = "compliance",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",
  apexId = "apexId",
  fullName = "fullName",
  rowNum = "rowNum",
  errorMessage = "errorMessage"
};

enum FieldLabel {
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",
  DRIVER_NAME = "ml_143908",
  KPI_NAME = "ml_143913",
  YEAR_AND_MONTH = "ml_143914",
  COMPLANCE = "ml_143915",
  DRIVER_APEX_ID = "ml_143930",
  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.TERMINAL_ID,
    name: OrgUnitFieldName.terminalId,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: OrgUnitFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: OrgUnitFieldName.subRegionName,
    sort: true,
  },
  {
    text: FieldLabel.COUNTRY,
    name: OrgUnitFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.CREATED_BY,
    name: OrgUnitFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: OrgUnitFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  }
];

export const GetOrgUnitSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = OrgUnitSearchByList.slice();
  result[0].searchDropDownValue = terminals;
  result[1].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}

export const complianceSelectItems = [{ value: true, label: "ml_143931" }, { value: false, label: "ml_143932" }];

const OrgUnitSearchByList: SearchByItem[] = [
  { searchBy: OrgUnitFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: OrgUnitFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] }
];
